let Translations = {
    fr: {
        search: 'Chercher'
    },
    en: {
        search: 'Search'
    },
    zh: {
        search: '搜索'
    }
};
export {Translations}